import { useEffect } from 'react';
import { SOURCE_LANGUAGE } from '../constants/languages';
import { createPageTranslator } from '../engine/createPageTranslator';
import { translateBatch } from '../services/translationService';
import { translationCache } from '../utils/translationCache';
import { useLanguage } from './useLanguage';

/**
 * Starts the page translator while a non-English language is selected and stops it on cleanup.
 * English needs nothing: it is the page exactly as React drew it.
 */
export const usePageTranslator = () => {
    const { language, setTranslationStatus } = useLanguage();

    useEffect(() => {
        if (language === SOURCE_LANGUAGE) return undefined;

        const translator = createPageTranslator({
            targetLanguage: language,
            translateBatch,
            cache: translationCache,
            onStatus: setTranslationStatus,
        });
        translator.start();

        return () => translator.destroy();
    }, [language, setTranslationStatus]);
};
